export default function AboutPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>关于我们页面建设中...</p>
    </div>
  );
}